import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CalculatorCard from "./components/CalculatorCard"; // Importing the CalculatorCard component
import RandomGenerator from "./components/RandomGenerator"; // Importing RandomGenerator component
import CanvasMountains from "./components/canvas/CanvasMountains";
import CanvasTrees from "./components/canvas/CanvasBeach";
import CanvasRocks from "./components/canvas/CanvasJungle";
import CanvasClouds from "./components/canvas/CanvasSnow";
import { validateOneToSix } from "./components/CustomValidators";
import { validateTimeLines } from "./components/CustomValidators";
import { validateDungeonTimeLines } from "./components/CustomValidators";
import { validateDungeonAge } from "./components/CustomValidators";
import attack2attack from "./images/Attack2Attack.png"
import baseHealth from "./images/baseHealth.png"
import ownattack from "./images/OwnAttackFind.png"
import timeline from "./images/TimeLine.png"
import dungeons from "./images/dungeonLvls.png"
import CustomCalculatorCard from "./components/CustomCalulatorCard";
import CustomCalculatorCard2 from "./components/CustomCalculatorCard2";
import HeroCardCalculator from "./components/HeroCardCalculator";
import HeroCardCalculatorUpdate from "./components/HeroCardCalculatorUpdate";
import CardCalculator from "./components/CardCalculator";
import ExpandableContent from "./components/ExpandableContent";
import TwoDayCalculatorUpdate from "./components/TwoDayCalculatorUpdate";

const backgroundOptions = [
  { color: "bg-blue-100", art: "mountains" },
  { color: "bg-green-100", art: "trees" },
  { color: "bg-gray-200", art: "rocks" },
  { color: "bg-sky-200", art: "clouds" },
];

export default function App() {
  const [selectedBg, setSelectedBg] = useState(0);

  useEffect((prev) => {
    const randomIndex = Math.floor(Math.random() * backgroundOptions.length);
    setSelectedBg(backgroundOptions[randomIndex]);
  }, []);

  const renderCanvas = () => {
    switch (selectedBg?.art) {
      case "mountains":
        return <CanvasMountains />;
      case "trees":
        return <CanvasTrees />;
      case "rocks":
        return <CanvasRocks />;
      case "clouds":
        return <CanvasClouds />;
      default:
        return null;
    }
  };

 // Define the number of inputs for each calculator card
 const calculatorConfigs = [
  { numInputs: 1, 
    logicType: "Attack To Timeline", 
    description: "Use your attack stat in the paranthesis and not your unit's attack number. It is case sensitive. Finds the matching timeline of the Enemy based on your attack stat. ",
    inputs: [{ label: "Your Attack Stat", placeholder: "e.g. 100A"}],
    img: ownattack
  },
  { numInputs: 2, 
    logicType: "Attack Vs Attack", 
    description: "Calculates when the enemy will have similar attack values and states how many trophies and blue potion you will obtain. Depending where you are at, you can get to the same attack, 10x attack, or 30x attack of the enemies. Similar to the top caculator but only up to matching attack stats. Use the values in paranthesis in i icon comparison.",
    inputs:[
      { label: "Your Attack Stat", placeholder: "e.g. 100A"},
      { label: "Enemy Attack Stat", placeholder: "e.g. 10A"}
    ],
    img: attack2attack,
  },
  {
    numInputs: 1,
    logicType: "Check TL Stats",
    description: "Check the stats of the enemy for any timeline. Useful to know upcoming unit stats, and knowing other player stats, some players can go up to 10 or 30 times their stats, added that too. It is limited to only the first 6000 timelines.",
    inputs:[{label: "Enemy Timeline", placeholder: "e.g. 80"}],
    customValidationByIndex: {
      0: validateTimeLines
    },
    img: timeline
  },
  {
    numInputs: 2, 
    logicType: "Dungeon Stats", 
    description: "Checks the stats of the Dungeons. A work in progress, haven't figured out right rounding and Legends. Will state attack and health roughly.",
    inputs: [
      {label: "Dungeon Main Timeline", placeholder:"e.g. 20"},
      {label: "Dungeon Sub Timeline", placeholder:"e.g. 10"}],
    customValidationByIndex: {
      0: validateDungeonTimeLines,
      1: validateDungeonAge
    },
    img: dungeons
  },
  {
    numInputs: 5,
    logicType: "Base Health Catch Up",
    description: "Calculates the possibility of having a similar base health to the enemy. Since coin generation is varied, it takes what is considered unreasonable by your situation. It uses this number for various calculations. ",
    inputs: [
      { label: "Your Age", placeholder: "e.g. 5" },
      { label: "Your Base Health Stat", placeholder: "e.g. 200" },
      { label: "Enemy TimeLine", placeholder: "e.g. 300" },
      { label: "Enemy Age", placeholder: "e.g. 5" },
      { label: "An Amount Considered Too Costly Even with Ad Multiplier", placeholder: "e.g. 1b"}
    ],
    customValidationByIndex: {
      0: validateOneToSix,
      3: validateOneToSix,
    },
    img: baseHealth
  }

];

return (
  <div className={`${selectedBg?.color || ""} relative min-h-screen`}>
    {/* Background Art Layer */}
    {renderCanvas()}

    {/* Foreground Content */}
  <div className="App relative z-10">
    {/* Header */}
    <Header />

    <div className="main-content container mx-auto p-4">
      {/* Random Generator */}
      <div className="random-generator mb-6">
        <RandomGenerator />
      </div>

      {/* Calculator Cards */}
      <div className="calculator-card-container grid grid-cols-1 gap-6 ">
        <CardCalculator />
        <ExpandableContent title = "Old Hero Calculator">
          <HeroCardCalculator />
        </ExpandableContent>
        <HeroCardCalculatorUpdate />
        
        {calculatorConfigs.map((config, index) => (
          <CalculatorCard
          key={index}
          numInputs={config.numInputs} 
          logicType={config.logicType}  
          description={config.description}
          inputs={config.inputs}
          customValidationByIndex={config.customValidationByIndex}
          img = {config.img}
        />
        ))}
        <CustomCalculatorCard />
        <ExpandableContent title = "Old Two Day Calculator">
          <CustomCalculatorCard2 />
        </ExpandableContent>
        <TwoDayCalculatorUpdate />
        
      </div>
    </div>

    {/* Footer */}
    <Footer />
  </div>
</div>
);
}